import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function RefundPolicyPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="refund-policy-page">
      <Header />
      <div className="pt-[72px]">
        <div className="bg-[#0B132B] py-16 md:py-20">
          <div className="w-full px-6 md:px-10 lg:px-16 xl:px-24">
            <h1 className="text-4xl sm:text-5xl tracking-tighter font-black text-white" style={{ fontFamily: 'Chivo, sans-serif' }}>Refund Policy</h1>
            <p className="text-slate-400 mt-3 text-base">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
          </div>
        </div>
        <div className="max-w-5xl mx-auto px-6 lg:px-16 py-16 md:py-20" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-bold text-[#0B132B] mb-3" style={{ fontFamily: 'Chivo, sans-serif' }}>1. Refund Eligibility</h2>
              <p className="text-base leading-relaxed text-[#475569]">Refund requests are evaluated on a case-by-case basis. Clients may request a refund within 30 days of service commencement if the services delivered do not meet the specifications outlined in the agreed statement of work or service agreement.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-[#0B132B] mb-3" style={{ fontFamily: 'Chivo, sans-serif' }}>2. Non-Refundable Services</h2>
              <p className="text-base leading-relaxed text-[#475569]">The following are generally non-refundable: consulting hours already rendered, infrastructure resources already provisioned and utilized, custom development work delivered and accepted, and any third-party licensing fees incurred on behalf of the client.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-[#0B132B] mb-3" style={{ fontFamily: 'Chivo, sans-serif' }}>3. Refund Process</h2>
              <p className="text-base leading-relaxed text-[#475569]">To request a refund, please contact us at aiauroratechprivatelimited@gmail.com with your account details and the reason for the refund request. We will review your request within 5-7 business days and notify you of the status. Approved refunds will be processed within 14 business days.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-[#0B132B] mb-3" style={{ fontFamily: 'Chivo, sans-serif' }}>4. Partial Refunds</h2>
              <p className="text-base leading-relaxed text-[#475569]">In cases where services have been partially delivered, a partial refund may be issued proportional to the unused portion of the services. The calculation will be based on the service milestones outlined in the agreement.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-[#0B132B] mb-3" style={{ fontFamily: 'Chivo, sans-serif' }}>5. Subscription Cancellations</h2>
              <p className="text-base leading-relaxed text-[#475569]">For subscription-based services, you may cancel at any time. Upon cancellation, you will continue to have access until the end of the current billing period. No refunds will be issued for partial billing periods unless otherwise specified in your service agreement.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-[#0B132B] mb-3" style={{ fontFamily: 'Chivo, sans-serif' }}>6. Contact</h2>
              <p className="text-base leading-relaxed text-[#475569]">For refund inquiries, contact us at aiauroratechprivatelimited@gmail.com or at 7901 4th Street NORTH STE 300, ST. PETERSBURG, FL. 33702.</p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
